import axiosClient  from "../Network/apiClient"
import localStorageService, {keys} from './LocalStorageService'

const UserService = {

    authenticate: (username, password, project) => {
        const projectId = project || parseInt(process.env.REACT_APP_PROJECTID)
        const deviceId = localStorageService.getItem(keys.DEVICE) || -1;
        return axiosClient.post('/Users/authenticate',JSON.stringify({username,password,projectId,deviceId}));
    },

    register: (user) => {
        user.projectId = parseInt(process.env.REACT_APP_PROJECTID)
        return axiosClient.post('/Users/register',JSON.stringify(user));
    },

    buddies: (search) => {
        return axiosClient.get(`/Users/buddies?search=${search}`);
    },


}

export default UserService
